module.exports = {
  width: 19,
  fontSize: 12,
  interval: 60,
  color: '#61c11a',
  bright: '#d7d7d7'
};
